import { TableColumnsType } from "antd";

export type ExpendedShipmentRow = {
  asin: string;
  sku: string;
  quantity: number;
  weight: string;
};

export type ShipmentRow = {
  shipmentOrderId: string;
  purchaseOrderId: string;
  status: string;
  freightMethod: string;
  shipmentCost: string;
  issueDate: string;
  shipmentDate: string;
  estDeliveryDate: string;
  actualDeliveryDate: string;
  destination: string;
  items: ExpendedShipmentRow[];
};

export const expendedShipmentColumns: TableColumnsType<ExpendedShipmentRow> = [
  { title: "ASIN", dataIndex: "asin", key: "asin" },
  { title: "SKU", dataIndex: "sku", key: "sku" },
  { title: "Quantity", dataIndex: "quantity", key: "quantity" },
  { title: "Weight", dataIndex: "weight", key: "weight" },
];

export const shipmentData: ShipmentRow[] = [
  {
    shipmentOrderId: "92392",
    purchaseOrderId: "73292",
    status: "Open",
    freightMethod: "Air",
    shipmentCost: "£3,500",
    issueDate: "01.01.2024",
    shipmentDate: "03.01.2024",
    estDeliveryDate: "05.01.2024",
    actualDeliveryDate: "05.01.2024",
    destination: "Wales, UK, 90 Orange St, EC1A 1AH",
    items: [
      {
        asin: "B0D5MNJWR9",
        sku: "KJG85903G",
        quantity: 332,
        weight: "320lb",
      },
      {
        asin: "B0D5MNJW7",
        sku: "KJG85903G",
        quantity: 332,
        weight: "320lb",
      },
    ],
  },
  {
    shipmentOrderId: "92393",
    purchaseOrderId: "73293",
    status: "Cancelled",
    freightMethod: "Sea",
    shipmentCost: "£2,100",
    issueDate: "10.01.2024",
    shipmentDate: "12.01.2024",
    estDeliveryDate: "25.01.2024",
    actualDeliveryDate: "",
    destination: "London, UK, 21 Green Rd, SW1A 1AA",
    items: [
      {
        asin: "B0D5AB1234",
        sku: "ZXCVBN123",
        quantity: 150,
        weight: "500lb",
      },
      {
        asin: "B0D5AB5678",
        sku: "ZXCVBN456",
        quantity: 200,
        weight: "450lb",
      },
    ],
  },
  {
    shipmentOrderId: "92394",
    purchaseOrderId: "73294",
    status: "Closed",
    freightMethod: "Rail",
    shipmentCost: "£1,800",
    issueDate: "15.01.2024",
    shipmentDate: "16.01.2024",
    estDeliveryDate: "20.01.2024",
    actualDeliveryDate: "19.01.2024",
    destination: "Manchester, UK, 12 Red Ave, M1 1AE",
    items: [
      {
        asin: "B0XYZ12345",
        sku: "PLM98765",
        quantity: 120,
        weight: "270lb",
      },
    ],
  },
];
